import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { FooterBottomContainer, FooterLegalLinks } from './footer.styles';
import { TextCopyright } from '../../common/typography/typography.styles';
import { useStore } from '../../stores/store';
import { FooterLinks } from '../../models/footerLinksModel';
import { isFeatureRequired } from '../../utils/client/client.utils';
import { generateLocaleRoute } from '../../utils/uri/uri.utils';
import { AppRoute } from '../../constants/route';

interface Props {
  links: FooterLinks | undefined;
}

const FooterBottom = ({ links }: Props) => {
  const {
    marketingStore: { countriesWithTermsAndConditions },
    localizationsStore: { selectedCountry },
  } = useStore();

  const { t } = useTranslation();

  const currentYear = new Date().getFullYear();

  return (
    <FooterBottomContainer>
      <TextCopyright>
        © {currentYear} - {`${t('footer_postal_and_transport_services')}. `}
        {t('all_rights_reserved')}
      </TextCopyright>

      {links && (
        <FooterLegalLinks>
          {links.privacy_policy && (
            <a href={links.privacy_policy}>{t('footer_privacy_policy')}</a>
          )}
          {links.terms_of_use && (
            <a href={links.terms_of_use}>
              {countriesWithTermsAndConditions.includes(
                selectedCountry?.country_code ?? ''
              )
                ? t('footer_terms_and_conditions')
                : t('footer_terms_of_use')}
            </a>
          )}
          {links.delivery_rules && (
            <a href={links.delivery_rules}>{t('footer_delivery_rules')}</a>
          )}
          {isFeatureRequired('privacyOptLinkRequired') && (
            <a href={generateLocaleRoute(AppRoute.PRIVACY_OPT_OUT)}>
              {t('do_not_share_page_link')}
            </a>
          )}
        </FooterLegalLinks>
      )}
    </FooterBottomContainer>
  );
};

export default observer(FooterBottom);
